module.exports = require("core-js-pure/features/instance/reduce");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/reduce.js
// module id = 479
// module chunks = 13